<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Manage Sites"
              icon="fas fa-list">
          </card-section-header>
          <!-- Filters -->
          <div class="form-row">
            <div class="row">
              <div class="col-md-12">
                <div class="filter-flex-row">
                  <div>
                    <label>Site Name:</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChangedSite($event, 'filterName')"></text-filter-box>
                  </div>
                  <div *ngIf="isFilterLoading" class="small-spinner">
                    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                  </div>
                </div>
                <br>
              </div>
            </div>

          </div>
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <!-- [lazy] must be set before [sortField]/[sortOrder]: 
                   Paging and sorting are server-side, only ever holds the current page. 
                   Without lazy, the table would also client-sort that one page, 
                   briefly showing a wrong order over the server's result -->
             <p-table
                  [lazy]="true"
                  [value]="sites"
                  selectionMode="single"
                  [(selection)]="selectedSite"
                  (onRowSelect)="onRowSelect($event)"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th [pSortableColumn]="'name'">
                      Site Name
                      <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th>Description</th>
                    <th>Owner</th>
                    <th [pSortableColumn]="'siteType.name'">
                      Type
                      <p-sortIcon [field]="'siteType.name'"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-site>
                  <tr [pSelectableRow]="site">
                    <td>{{ site.name }} / S{{ site.id }}</td>
                    <td>{{ site.description }}</td>
                    <td>{{ site.siteOwner.firstName }} {{ site.siteOwner.lastName }}</td>
                    <td>{{ site.siteType.name }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">No sites found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

